export const InvoiceStatus = {
  PENDING: "pending",
  PAID: "paid",
};
